import { defineComponent, ref, type VNode, watch } from 'vue'
import type { IQRImageProps } from './types'
// @ts-ignore - qrcode doesn't have type declarations
import QRCode from 'qrcode'
import { isHTMLElement } from '@/utils/is'

const QRImage = defineComponent<IQRImageProps>({
  name: 'QRImage',
  setup(props) {
    const imgRef = ref<VNode>()

    const generateImageURL = async (dataString: string) => {
      const url = await QRCode.toDataURL(dataString)

      const ele = isHTMLElement(imgRef.value) ? imgRef.value : imgRef?.value?.el
      if (imgRef.value && ele) {
        const el = ele as HTMLImageElement
        el.setAttribute('src', url)
        el.src = url
      }
    }

    watch(
      props,
      async (_) => {
        await generateImageURL(props.qrstring)
      },
      { immediate: true, deep: true }
    )

    return () => {
      return (
        <div
          style={{
            width: '100%',
            height: '100%'
          }}
        >
          <img
            ref={imgRef}
            style={{
              width: '100%',
              height: '100%',
              display: 'block'
            }}
          />
        </div>
      )
    }
  }
})

QRImage.props = ['qrstring']

export default QRImage
